import { Api } from "../constants";
import { post } from "../helpers/apiHelper";
import { SearchItemsParams } from "../types";

export async function searchItemsApi({
  lat,
  lon,
  userId,
  keyword,
  radiusInKm = 50,
  itemCondition = [],
  itemCategory = [],
  sortKey = "NEAR_ME",
  itemsPerPage = 10,
  pageNo = 1,
}: SearchItemsParams) {
  const url = `${Api.searchItems}`;
  return await post(url, {
    lat,
    lon,
    userId,
    keyword,
    radiusInKm,
    itemCondition,
    itemCategory,
    sortKey,
    itemsPerPage,
    pageNo,
  });
}
